<div class="page-container">
    <div class="section-container">
        <div class="kn-page-title">HTML Analyzer</div>
        <kn-button [buttonId]="'exampleButton'" [buttonType]="'kn-primary'" [buttonText]="'Button'" (btnClick)="scanUrl()"></kn-button>
        <kn-button [buttonId]="'exampleButton'" [buttonType]="'kn-primary'" [buttonText]="'Button'" (btnClick)="scanUrl()"></kn-button>
    </div>
</div>
